module.exports = __webpack_public_path__ + "img/product.e5630f50.png";